var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxLocation = function Svg18PxLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13 12.582c1.959.358 3.25.972 3.25 1.668 0 1.105-3.246 2-7.25 2s-7.25-.895-7.25-2c0-.697 1.291-1.31 3.25-1.668"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.429 5.978C13.429 8.587 9 13.25 9 13.25S4.571 8.588 4.571 5.978C4.571 3.303 6.86 1.75 9 1.75s4.429 1.552 4.429 4.228"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  })));
};
export default Svg18PxLocation;